export default {
    methods: {
        restrictLoadEdit(load) {
            return (load.status === 'invoiced') && this.$store.state.loadCompleted && !this.$store.getters.role.includes('admin') && !this.$store.getters.role.includes('accounting')
        }
    }
}
